export const BaseLineFeedback = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21 12V16.5C21 17.3284 20.3284 18 19.5 18H14.5L12 20.5L9.5 18H4.5C3.67157 18 3 17.3284 3 16.5V5.5C3 4.67157 3.67157 4 4.5 4H13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M21 4L12 12" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
